import type { SVGProps } from 'react';

function IconBriefcaseMedical(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M264 112L376 112C380.4 112 384 115.6 384 120L384 160L256 160L256 120C256 115.6 259.6 112 264 112zM208 120L208 160L128 160C92.7 160 64 188.7 64 224L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 224C576 188.7 547.3 160 512 160L432 160L432 120C432 89.1 406.9 64 376 64L264 64C233.1 64 208 89.1 208 120zM232 208L512 208C520.8 208 528 215.2 528 224L528 480C528 488.8 520.8 496 512 496L128 496C119.2 496 112 488.8 112 480L112 224C112 215.2 119.2 208 128 208L232 208zM288 280L288 320L248 320C239.2 320 232 327.2 232 336L232 368C232 376.8 239.2 384 248 384L288 384L288 424C288 432.8 295.2 440 304 440L336 440C344.8 440 352 432.8 352 424L352 384L392 384C400.8 384 408 376.8 408 368L408 336C408 327.2 400.8 320 392 320L352 320L352 280C352 271.2 344.8 264 336 264L304 264C295.2 264 288 271.2 288 280z"
                fill="currentColor"
            />
        </svg>
    );
}

export default IconBriefcaseMedical;
